import PropTypes from 'prop-types'
import classNames from 'classnames'
import React, { Component } from 'react'
import omit from 'lodash/omit'

import RouterLink from 'base/components/router_link'

const possibleColors = [
  'orange',
  'cta',
  'twitter',
  'facebook',
  'google',
  'white',
  'almost-white',
  'barely-grey',
  'light-grey',
  'grey',
  'medium-grey',
  'dark-grey',
  'paypal',
  'sofort',
  'green',
  'black',
  'cta-orange',
]

class FlatButton extends Component {
  possibleColors = possibleColors

  static propTypes = {
    className: PropTypes.string,
    href: PropTypes.string,
    color: PropTypes.oneOf(possibleColors),
    fullWidth: PropTypes.bool,
    size: PropTypes.string,
    disabled: PropTypes.bool,
    type: PropTypes.string,
    style: PropTypes.string,
  }

  static defaultProps = {
    color: 'light-grey',
    fullWidth: false,
    type: 'button',
  }

  render() {
    const className = classNames('flat-button', this.props.className, {
      [`flat-button--${this.props.color}`]: this.props.color,
      'flat-button--full-width': this.props.fullWidth,
      'flat-button--small': this.props.size === 'small',
      'flat-button--disabled': this.props.disabled,
    })

    const otherProps = omit(this.props, 'fullWidth', 'color', 'size')

    if (this.props.href) {
      return (
        <RouterLink {...otherProps} className={className} style={this.props.style}>
          {this.props.children}
        </RouterLink>
      )
    } else {
      return (
        <button
          {...otherProps}
          className={className}
          type={this.props.type}
          ref={el => (this.buttonRef = el)}
          style={this.props.style}
        >
          {this.props.children}
        </button>
      )
    }
  }
}

export default FlatButton
